import {h, Fragment} from "preact"
import { useEffect, useState } from "preact/hooks";

export default function VariantsRelated({ product, onVariantClick }) {
    const [variantsAlt, setVariantsAlt] = useState("");

    async function fetchProductId(url) {
        try {
            const html = await window.getId(url);
            if (typeof html !== "string") {
                throw new Error("El ID obtenido no es una cadena válida.");
            }
            return html;
        } catch (error) {
            console.error("Error obteniendo el ID:", error);
            return null;
        }
    }

    useEffect(() => {
        let isMounted = true;

        async function getVariantsRelated() {
            const html = await fetchProductId(product.url);
            if (isMounted && html) {
                setVariantsAlt(html);
            }
        }

        getVariantsRelated();

        return () => {
            isMounted = false;
        };
    }, [product.url]);

    function handleSwatchClick(e) {
        const price = e.target.closest(".swatch").dataset.price;
        const comparePrice = e.target.closest(".swatch").dataset.comparePrice;
        const primaryImage = e.target.closest(".swatch").dataset.primaryImage;
        const secondaryImage = e.target.closest(".swatch").dataset.secondaryImage;
        if (primaryImage && onVariantClick) {
            onVariantClick(primaryImage, secondaryImage, price, comparePrice);
        }
    }

    return (
        <div
            dangerouslySetInnerHTML={{ __html: variantsAlt }}
            onClick={(e) => {
                if (e.target.closest(".swatch")) {
                    handleSwatchClick(e);
                }
            }}
        ></div>
    );
}
